export class ConsoleLogger {

	/**
	 * Does not apply any formatting on it's own.
	 * See class {@link LogMessageFormatter}.
	 */
	public static debug(source: String, msg: string) {
		console.debug(source + " - " + msg);
	}

	/**
	 * Does not apply any formatting on it's own.
	 * See class {@link LogMessageFormatter}.
	 */
	public static info(source: String, msg: string) {
		console.info(source + " - " + msg);
	}

	/**
	 * Does not apply any formatting on it's own.
	 * See class {@link LogMessageFormatter}.
	 */
	public static warn(source: String, msg: string) {
		console.warn(source + " - " + msg);
	}

	/**
	 * Does not apply any formatting on it's own.
	 * See class {@link LogMessageFormatter}.
	 */
	public static error(source: String, msg: string) {
		console.error(source + " - " + msg);
	}
}
